// @Dev: This is added for disabling setting of redis
// cache for html generated at server-side containing div/any tag
// with id="live-webinar-no-cache" (for eg.)
// used here server/cacheHandler.ts and
// src/components/eventPage/components/ScheduleSelector/Components/GetScheduleComponent/index.tsx
// This is specifically done for live webinar as html was generated(express interest) using
// expired slots when limiting the sessions to 1(this shows the latest available slot)
// as no new api call was made.

export const DISABLE_CACHE_IDS = {
    webinar: "live-webinar-no-cache",
};
